module.exports = __webpack_public_path__ + "static/media/client_4.111ac2c0.png";